import React from 'react'
import cn from 'classnames'
import styles from 'components/panels/stream-order.module.scss'
import WithTooltip from 'components/shared/WithTooltip'
import useStreamFilter from 'components/filters/useStreamFilters'
import useStore from 'state/knovStore'
import queryClient from 'api/queryClient'
import { serializeFilterKey } from 'refactor/hooks/api/useGetQuests'
import { Filter } from 'components/filters/useStreamFilters'

// Define and Export Stream Order Configurations
export const streamOrderConfigs = {
    upvote: {
        icon: 'fa fa-arrow-up fa-large',
        label: 'Top',
        tip: 'Messages sorted by upvotes',
    },
    upvoteTrending: {
        icon: 'fa fa-fire',
        label: 'Hot',
        tip: 'Messages sorted by recency and upvotes',
    },
    upvalue: {
        //icon: 'fa fa-bitcoin fa-large',
        icon: 'fa fa-arrow-up fa-large',
        label: 'Top',
        tip: 'Messages sorted by upvalue',
    },
    upvalueTrending: {
        icon: 'fa fa-fire',
        label: 'Hot',
        tip: 'Messages sorted by recency and upvalue',
    },
    relevance: {
        icon: 'fa fa-search',
        label: 'Relev',
        tip: 'Messages sorted by relevance',
    },
    time: {
        icon: 'fa fa-clock-o',
        label: 'New',
        tip: 'Recently created messages.',
    },
}

// Define and Export Filter Mapping Logic
export const getFilterMapping = (filter: Filter | undefined | null) => {
    const hasSearchQuery = !!filter?.query
    const isPublic = filter?.public || filter?.treechat || filter?.hodlocker
    const isPublicTeam =
        filter?.team_ids?.length > 0 &&
        useStore.getState().publicTeams?.some(team => filter?.team_ids?.includes(team.id))
    const isMeme = filter?.meme
    const isUser = filter?.user

    const defaultSearchOrder = {
        time: streamOrderConfigs.time,
        upvoteTrending: streamOrderConfigs.upvoteTrending,
        upvote: streamOrderConfigs.upvote,
    }
    const publicOrder = {
        time: streamOrderConfigs.time,
        upvalueTrending: streamOrderConfigs.upvalueTrending,
        upvalue: streamOrderConfigs.upvalue,
    }

    if (hasSearchQuery) {
        return { relevance: streamOrderConfigs.relevance }
    } else if (isPublic || isPublicTeam || isMeme || isUser) {
        return { ...publicOrder }
    } else {
        return defaultSearchOrder
    }
}

interface StreamOrderProps {
    filter: Filter | undefined | null
    panelId: string
    panel: any
    query?: string
}

export default function StreamOrder({ panelId, filter, panel, query }: StreamOrderProps) {
    const { setStreamFilter } = useStreamFilter(panelId)

    // Use the exported logic
    const filterMapping = getFilterMapping(filter)

    return (
        <div className={styles.streamOrderComp}>
            <div className={styles.orderBtnContainer}>
                {Object.entries(filterMapping).map(([filterKey, filterValue]) => {
                    // Determine the default key if filter.order is not set
                    const defaultFilterKey = Object.keys(filterMapping)[0]
                    const isSelected =
                        filter?.query ||
                        filter?.order === filterKey ||
                        (!filter?.order && filterKey === defaultFilterKey)
                    const orderBtnStyles = cn(styles.orderBtn, isSelected && styles.selected)
                    const { icon, label, tip } = filterValue
                    return (
                        <div key={label} style={{ flex: 1 }}>
                            <WithTooltip key={filterKey} tip={tip}>
                                <div
                                    className={orderBtnStyles}
                                    onClick={ev => {
                                        ev.stopPropagation()
                                        ev.preventDefault()

                                        const newFilter = { ...filter, order: filterKey }

                                        // Invalidate useGetQuests query cache with the new filter
                                        const serializedFilterKey = serializeFilterKey(newFilter)
                                        queryClient.invalidateQueries({
                                            queryKey: ['quests', serializedFilterKey],
                                            exact: true,
                                        })

                                        setStreamFilter(newFilter)
                                    }}
                                >
                                    <i className={icon} />
                                    <span className={styles.orderLabel}>{label}</span>
                                </div>
                            </WithTooltip>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}
